export default "__VITE_ASSET__24bb0a73__"